var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.818 7.401c-.297-.267-.628-.468-1.024-.535c-.495-.067-.99.268-1.32.502c-.33.235-.992.838-1.256 1.072s-.925.368-2.014 1.039c-1.09.67-5.318 3.416-5.318 3.416h1.09l-4.92 2.58h.494l-.693.535c.396.101.793.034 1.156-.167v.167s5.845-2.344 6.968-1.741l-.693.201c.066 0 1.156.067 1.156.067c.066.469.33.904.727 1.139c.66.435.693.703.693.703s-.33.134-.33.335a3 3 0 0 1 1.882 0s-.033-.201-.495-.335a2.63 2.63 0 0 1-1.156-.938c-.264-.368-.363-.837-.198-1.273s.726-.67 1.882-1.272c1.355-.704 1.685-1.24 1.85-1.676s.495-1.239.628-1.641c.131-.369.363-.67.66-.938a8 8 0 0 1 1.123-.502c.066.033-.66-.57-.892-.738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsm);
export default __webpack_public_path__ + "static/media/ksm.befdfa180526479ea3434dbb5418df68.svg";
export { ForwardRef as ReactComponent };